import {MasterMenuItemsService} from "../../../../../tramitantes/src/app/services/menu/master-menu-items.service";
import {Injectable} from "@angular/core";
import {MenuItem} from "primeng/api";


@Injectable()
export class SisbenMenuItemsService extends MasterMenuItemsService {


  getMenuItems(translations: any, isLoggedIn: boolean): MenuItem[] {
    return [{
      label: 'Consulta SISBEN', icon: 'pi pi-search', routerLink: ['/tramites/consulta-sisben'], visible: isLoggedIn
    }]
  }
}
